import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import { Input } from "decorator-form";
import InputType from "../../common/form/InputType";
import Product from "./entities/Product";

const productSelect = EntitySelect.registered({entity: Product, type: 'one'}, 'string');

export default class {

	@Input({type: InputType.TEXT, title: "Title"})
	public title: string;

	@Input({type: productSelect, title: "Product"})
	public product: Product;

	@Input({type: InputType.NUMBER, title: "Max Tags"})
	public size: number;

	@Input({type: InputType.CHECKBOX, title: "Tags as text list"})
	public textList?: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/subscriptionTags/SubscriptionTagsConfig.ts